import { tv } from "../../variants/tv.js";
const inputSelectVariants = tv({
    slots: {
        root: 'flex w-full items-center justify-between gap-2',
        labelSlot: 'text-body2',
        selectBoxWrapper: 'grid grid-cols-1 items-center',
        selectBox: [
            'relative col-start-1 row-start-1 w-full appearance-none py-2 pl-4 pr-8',
            'border-primary-6 rounded-xl border',
            'focus-visible:outline-primary-8 focus-visible:shadow-input-focus',
            'hover:border-primary-10 hover:shadow-input-hover hover:cursor-pointer'
        ],
        dropdownIcon: 'pointer-events-none col-start-1 row-start-1 mr-2 self-center justify-self-end'
    },
    variants: {
        size: {
            sm: {
                selectBox: 'h-[32px]'
            },
            md: {
                selectBox: 'h-[48px]'
            },
            lg: {
                selectBox: 'h-[56px]'
            }
        }
    },
    defaultVariants: {
        size: 'md'
    }
});
export { inputSelectVariants };
